import { matchPath } from 'react-router-dom';
import { SALESFORCE_AUTH_ROUTE } from '~/_shared/constants/routes';

export const isSalesforceAuthRoute = (pathname: string): boolean => {
  return !!matchPath({ path: SALESFORCE_AUTH_ROUTE, end: false }, pathname);
};
